// Declarações (/c/declarations e /e/declarations): tipos, quem pode enviar anônima,
// validação do envio e os rótulos da lista. O back grava a empresa e o autor pelo
// usuário, e a anônima (`identify: false`) nunca traz o autor, nem para o ADM.

// O enum `type` do back, na mesma ordem
export const DECLARATION_TYPES = ["Dúvida", "Sugestão", "Reclamação", "Elogio", "Outros"].map((type) => ({
  label: type,
  value: type,
}));

/** Ids dos campos do envio, usados nos erros e no foco. */
export const DECLARATION_FIELDS = { type: "declaration-type", text: "declaration-text", identify: "declaration-identify" };

/** A empresa aceita declaração anônima (parâmetro em Configurações, lido do `user_ow`). */
export function canSendAnonymous(user) {
  return user?.companyData?.parameters?.permitAnnonymousDeclarations === true;
}

export const emptyDeclaration = () => ({ type: "", text: "", identify: true });

/** Erros por id de campo; vazio quando dá para enviar. */
export function validateDeclaration(form) {
  const errors = {};
  if (!form.type) errors[DECLARATION_FIELDS.type] = "Escolha o tipo.";
  if (!String(form.text || "").trim()) errors[DECLARATION_FIELDS.text] = "Escreva a declaração.";
  return errors;
}

/** Corpo do POST /declarations. Sem a anônima permitida, vai sempre com o nome. */
export function declarationPayload(form, allowAnonymous) {
  return {
    type: form.type,
    text: String(form.text || "").trim(),
    identify: allowAnonymous ? form.identify !== false : true,
  };
}

/** Quem enviou, como a lista e o modal mostram: o nome ou "Anônima". */
export function declarationAuthor(item) {
  return item?.identify && item.created_by?.name ? item.created_by.name : "Anônima";
}
